export default __webpack_public_path__ + "static/media/termsAndConditions.d246a93e.md";